import { PolicyUsage } from "@covertree/new-business-graphql";
import { ResidencyType } from "@covertree/types";

export function getResidencyTypeBasedOnPolicyUsage(
  policyUsage?: PolicyUsage
): ResidencyType | undefined {
  if (!policyUsage) return undefined;

  if (policyUsage === PolicyUsage.Tenant) {
    return ResidencyType.Tenant;
  }

  return ResidencyType.Owner;
}
